import { useMutation } from '@tanstack/react-query'

import { useNodeApi } from '../api-provider'

export const useRequestTaskRun = () => {
  const nodeApi = useNodeApi()
  const { urqlClient } = nodeApi

  return useMutation({
    mutationFn: async ({ tableId, taskId }: { tableId: string; taskId?: string }) => {
      if (!urqlClient) {
        throw new Error('Node API client is not available')
      }
      const result = await urqlClient
        .mutation(
          /* GraphQL */ `
            mutation RequestTaskRun($tableId: String!, $taskId: String) {
              requestVendia_TaskRun(tableId: $tableId, taskId: $taskId) {
                result {
                  isRequested
                }
              }
            }
          `,
          { tableId, taskId },
        )
        .toPromise()

      if (result.error) {
        throw new Error(result.error.message)
      }

      return result.data?.requestVendia_TaskRun.result
    },
    onError: (error) => {
      console.error('Error requesting task run:', error)
    },
  })
}
